import React from 'react'
import './view.css'
import Salessummary from '../../../../assets/Help/salesSummary.webp'
import Trendgraph from '../../../../assets/Help/trendGraph.webp'
import Bargraph from '../../../../assets/Help/barGraph.webp'
import Paymentimg from '../../../../assets/Help/payment.webp'
import Discounts from '../../../../assets/Help/discountsCoupons.webp'
import Topselling from '../../../../assets/Help/topSelling.webp'
import Transactions from '../../../../assets/Help/transactionsSummary.webp'
import Salestable from '../../../../assets/Help/salesTable.avif'
import { Box, Divider } from '@mui/material'
import { useThemeContext } from '../../../../Context/ThemeContext.js';
import { DARKCOLORS, LIGHTCOLORS } from '../../../../Utils/constants.js';
import { useTranslation } from 'react-i18next';

const View = () => {
    const { mode } = useThemeContext();
    const { t } = useTranslation();
    const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
    const containerBG = mode === 'dark' ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
    const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
    return (
        <div className='view-container'>
            <div
            // className='navigation-ol-list'
            >
                <Box>
                    <h1 className='home-title'>{t('help.viewTitle')} </h1>
                    <p style={{
                        color: subtitletext,
                        marginBottom: '20px'
                    }} className='home-subtitle'> {t('help.viewsubTitle')}</p>
                    <li className='home-keyFeature-text view-titles'>1. {t('help.viewsalesAnalytics')}
                        <Divider style={{ marginTop: '20px', marginBottom: '50px' }} />
                    </li>
                </Box>
                <Box className='today-sales-sec view-today-sales-sec'  >
                    <Box className=' nav-sec-div view-sales' >

                        <li className='home-Navi-bar-text spac1 number-structure  nowrapp'  style={{whiteSpace:'nowrap'
                            }}>1.1 {t('help.totalSalesSummary')}</li>
                        <p style={{
                            color: subtitletext
                        }} className='home-Navi-bar-text' >{t('help.totalSalesSummaryText')}</p>
                    </Box>
                    <Box className='nav-svg-sec'>
                        <img style={{
                            width: '90%',
                            // maxHeight: '500px',
                            marginTop: '12px',
                        }} src={Salessummary} alt="Todays-Sales" />
                    </Box>
                </Box>

                <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />


                <Box className='today-sales-sec view-today-sales-sec'>
                    <Box className=' nav-sec-div view-sales'  >

                        <li className='home-Navi-bar-text spac1 number-structure nowrapp'>1.2 {t('help.salesTrendGraphDisplay')} </li>
                        <p style={{
                            color: subtitletext
                        }} className='home-Navi-bar-text' >{t('help.salesTrendGraphDisplayText')}</p>
                    </Box>
                    <Box className='nav-svg-sec'>
                        <img style={{
                            width: '90%',

                            marginTop: '12px',
                        }} src={Trendgraph} alt="Todays-Sales" />
                    </Box>
                </Box>

                <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                <Box className='today-sales-sec view-today-sales-sec'>
                    <Box className=' nav-sec-div view-sales'  >

                        <li className='home-Navi-bar-text spac1 number-structure nowrapp'>1.3 {t('help.salesbyLocationBar')} </li>
                        <p style={{
                            color: subtitletext
                        }} className='home-Navi-bar-text' >{t('help.salesbyLocationBarText')}</p>
                    </Box>
                    <Box className='nav-svg-sec'>
                        <img style={{
                            width: '90%',
                            // maxHeight: '500px',
                            marginTop: '12px',
                        }} src={Bargraph} alt="Todays-Sales" />
                    </Box>
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />
                <Box className='today-sales-sec view-today-sales-sec'>
                    <Box className=' nav-sec-div view-sales'  >

                        <li className='home-Navi-bar-text spac1 number-structure nowrapp'>1.4 {t('help.locationSelectionButton')} </li>
                        <p style={{
                            color: subtitletext
                        }} className='home-Navi-bar-text' >{t('help.locationSelectionButtonText')}</p>
                    </Box>
                    
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                <Box className='today-sales-sec view-today-sales-sec'>
                    <Box className=' nav-sec-div view-sales'  >

                        <li className='home-Navi-bar-text spac1 number-structure nowrapp'>1.5 {t('help.calendarButton')} </li>
                        <p style={{
                            color: subtitletext
                        }} className='home-Navi-bar-text' >{t('help.calendarButtonText')} </p>
                    </Box>
                    {/* <Box className='nav-svg-sec'> */}
                    {/* <img style={{ width:'100%',
                                    // maxHeight: '500px',
                                    marginTop: '12px',
                                }} src="" alt="Todays-Sales" /> */}
                    {/* </Box> */}
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                <Box className='today-sales-sec view-today-sales-sec'>
                    <Box className=' nav-sec-div view-sales'  >

                        <li className='home-Navi-bar-text spac1 number-structure nowrapp'>1.6 {t('help.exportButton')}</li>
                        <p style={{
                            color: subtitletext
                        }} className='home-Navi-bar-text' >{t('help.exportButtonText')}</p>
                    </Box>
                    {/* <Box className='nav-svg-sec'> */}
                    {/* <img style={{ width:'100%',
                                        // maxHeight: '500px',
                                        marginTop: '12px',
                                    }} src="" alt="Todays-Sales" /> */}
                    {/* </Box> */}
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                <Box className='today-sales-sec view-today-sales-sec'>
                    <Box className=' nav-sec-div view-sales'  >

                        <li className='home-Navi-bar-text spac1 number-structure nowrapp'>1.7 {t('help.paymentMethodsPie')}</li>
                        <p style={{
                            color: subtitletext
                        }} className='home-Navi-bar-text' >{t('help.paymentMethodsPieText')}</p>
                    </Box>
                    <Box className='nav-svg-sec'>
                        <img className='view-img' style={{
                            width: '90%',
                            // maxHeight: '500px',
                            marginTop: '12px',
                        }} src={Paymentimg} alt="Pie Chart" />
                    </Box>
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                <Box className='today-sales-sec view-today-sales-sec'>
                    <Box className=' nav-sec-div view-sales'  >

                        <li className='home-Navi-bar-text spac1 number-structure nowrapp'>1.8 {t('help.discountsCoupons')}</li>
                        <p style={{
                            color: subtitletext
                        }} className='home-Navi-bar-text' >{t('help.discountsCouponsText')}</p>
                    </Box>
                    <Box className='nav-svg-sec'>
                        <img className='view-img' style={{
                            width: '90%',
                            // maxHeight: '500px',
                            marginTop: '12px',
                        }} src={Discounts} alt="Pie Chart" />
                    </Box>
                </Box>
                <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                <Box className='today-sales-sec view-today-sales-sec'>
                    <Box className=' nav-sec-div view-sales'  >

                        <li className='home-Navi-bar-text spac1 number-structure nowrapp'>1.9 {t('help.topSellingProducts')}</li>
                        <p style={{
                            color: subtitletext
                        }} className='home-Navi-bar-text' > {t('help.topSellingProductsText')}</p>
                    </Box>
                    <Box className='nav-svg-sec'>
                        <img className='view-img' style={{
                            width: '90%',
                            // maxHeight: '500px',
                            marginTop: '12px',
                        }} src={Topselling} alt="Top Selling table" />
                    </Box>
                </Box>

                <li className='home-keyFeature-text view-titles'>2. {t('help.transactions')}</li>
                <Divider style={{ marginTop: '20px', marginBottom: '50px' }} />

                <Box className="transaction-sec">
                    <Box className='today-sales-sec view-today-sales-sec'>
                        <Box className=' nav-sec-div view-sales'  >

                            <li className='home-Navi-bar-text spac1 number-structure nowrapp'>2.1 {t('help.transactionSummaryDisplay')}</li>
                            <p style={{
                                color: subtitletext
                            }} className='home-Navi-bar-text' >{t('help.transactionSummaryDisplaytext')}</p>
                        </Box>
                        <Box className='nav-svg-sec'>
                            <img className='view-img' style={{
                                width: '90%',
                                // maxHeight: '500px',
                                marginTop: '12px',
                            }} src={Transactions} alt="Todays-Sales" />
                        </Box>
                    </Box>
                    <Divider className='divider view-divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                    <Box className='today-sales-sec view-today-sales-sec'>
                        <Box className=' nav-sec-div  view-nav-sec-div'>
                            <li className='number-structure view-table-spac' style={{ marginTop: '20px', color: headingcolor }}>2.2 {t('help.table')}</li>
                            <ol
                             className='sec-1 list  view-lists'
                             >

                                <span style={{ padding: '0px' }} className='nav-tex-div'>
                                    <li style={{ color: headingcolor, marginRight: '10px' }} className='number-structure nowrapp'>2.2.1 {t('help.locationSelectionButton1')} {t('help.locationSelectionButton2')}</li>
                                    <p style={{ color: subtitletext }} className='home-Navi-bar-text'>{t('help.locationSelectionButtontext')}</p>
                                </span>
                                <span style={{ padding: '0px' }} className='nav-tex-div'>
                                    <li style={{ color: headingcolor, marginRight: '10px' }} className='number-structure nowrapp'>2.2.2 {t('help.transaction1')} {t('help.transaction2')}</li>
                                    <p style={{ color: subtitletext }} className='home-Navi-bar-text'>{t('help.transactiontext')}</p>
                                </span>
                                <span style={{ padding: '0px' }} className='nav-tex-div'>
                                    <li style={{ color: headingcolor, marginRight: '10px' }} className='number-structure nowrapp'>2.2.3 {t('help.exporthelpButton')}</li>
                                    <p style={{ color: subtitletext }} className='home-Navi-bar-text'>{t('help.exportButtontext')}</p>
                                </span>
                                <span style={{ padding: '0px' }} className='nav-tex-div'>
                                    <li style={{ color: headingcolor, marginRight: '10px' }} className='number-structure nowrapp'>2.2.4 {t('help.transactionTableDisplay')}{t('help.transactionTableDisplay2')}</li>
                                    <p style={{ color: subtitletext }} className='home-Navi-bar-text'>{t('help.transactionTableDisplayText')}</p>
                                </span>
                                <span style={{ padding: '0px' }} className='nav-tex-div'>
                                    <li style={{ color: headingcolor, marginRight: '10px',whiteSpace:'nowrap' }} className='number-structure nowrapp'>2.2.5 {t('help.pagination1')} {t('help.pagination12')}</li>
                                    <p style={{ color: subtitletext }} className='home-Navi-bar-text'>{t('help.paginationtext')}</p>
                                </span>
                            </ol>
                        </Box>
                        <Box className='nav-svg-sec'>
                            <img className='view-img' style={{
                                width: '90%',
                                // maxHeight: '500px',
                                marginTop: '12px',
                                backgroundColor: 'white',
                                borderRadius: '10px'
                            }} src={Salestable} alt="Todays-Sales" />
                        </Box>
                    </Box>

                </Box>
            </div >
        </div >
    )
}

export default View